module.exports = __webpack_public_path__ + "img/image13@3x.54e2dc79.png";